import { createStore } from 'vuex';
import User from './user/index';

export default createStore({
  modules: {
    user: User
  }
});
